import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Paper, Grid } from '@material-ui/core';
import STIHeaderView from "./STIHeaderView";
import StockInwardDtls from "../StockInwards/StockInwardDtls";
import UseFetchData from "../../../hooks/UseFetchData";

const StockInwardView = () => {
    debugger;
    const [IDMainData, setIDMainData] = useState([]);
    const [IDDtlsData, setIDDtlsData] = useState([]);
    // const [IDNoteData, setIDNoteData] = useState([]);
    // const [IDAttachData, setIDAttachData] = useState([]);
    // const [IDImageData, setIDImageData] = useState([]);
    // const [IDActivityData, setIDActivityData] = useState([]);
    const [ProductCount, setProductCount] = useState(0);
    const location = useLocation();
    const [responseViewDtls, fetchViewDtls] = UseFetchData();

    const getViewDtlsData = () => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("InventoryDocumentID", location.state.InventoryDocumentID);
        fetchViewDtls("StockInward/View", bodyFormData);
    }

    useEffect(() => {
        if (responseViewDtls.Main !== undefined && responseViewDtls.Main.length > 0) {
            setIDMainData(responseViewDtls.Main);
        }
        if (responseViewDtls.IDDtlsData !== undefined && responseViewDtls.IDDtlsData.length > 0) {
            setIDDtlsData(responseViewDtls.IDDtlsData);
            setProductCount(responseViewDtls.IDDtlsData.length);
        }
    }, [responseViewDtls]);

    useEffect(() => {
        getViewDtlsData();
    }, []);

    return (
        <Paper >
            <STIHeaderView
                InventoryDocumentID={location.state.InventoryDocumentID}
                IDMainData={IDMainData}
                PopulateData={getViewDtlsData}
                setProductCount={setProductCount}

            />
            <Grid container direction="row" style={{ marginTop: 7 }}>
                <Grid sm={12} xs={12}>
                    <Paper elevation={3} style={{ height: '100%' }}>
                        <StockInwardDtls
                            InventoryDocumentID={location.state.InventoryDocumentID}
                            IDMainData={IDMainData}
                            IDDtlsData={IDDtlsData}
                            PopulateData={getViewDtlsData}
                        // ProductCount={ProductCount}
                        // setProductCount={setProductCount}
                        />
                    </Paper>
                </Grid>

            </Grid>
        </Paper>
    );
}

export default StockInwardView;
